export enum TravelZone {
  Coventry = 'Coventry',
  SandWellAndDudley = 'Sandwell & Dudley',
  Walsall = 'Walsall',
  WestMidlands = 'West Midlands',
}

export const TravelZoneMap: Record<TravelZone, string> = {
  [TravelZone.Coventry]: 'travel_zone_coventry',
  [TravelZone.SandWellAndDudley]: 'travel_zone_sandwell_and_dudley',
  [TravelZone.Walsall]: 'travel_zone_walsall',
  [TravelZone.WestMidlands]: 'travel_zone_west_midlands',
};

export function getTravelZoneKey(
  maybeTravelZone: string | undefined
): string | undefined {
  return maybeTravelZone
    ? TravelZoneMap[maybeTravelZone as unknown as TravelZone]
    : undefined;
}
